import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { getGenresService } from "shared/services/general";
import styles from "./style.module.scss";
import GenreLandingPage from "shared/modals/genreLandingPage";

function ManageGenreOnLandingPages() {
  const [allGenres, setAllGenres] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [openGenreHandling, setOpenGenreHandling] = useState<boolean>(false);

  const getAllGenres = () => {
    setLoader(true);
    getGenresService()
      .then(({ data: { data } }) => {
        setLoader(false);
        setAllGenres(data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getAllGenres();
  }, []);


  return (
    <div className={styles.mainTableContainer}>
      <Box className={styles.tableHeadingContainer}>
        <div className={styles.headingContainer}>
          <div className={styles.heading}>
            Add or Remove Genre & book on Home Page
          </div>
          <div className={styles.subHeading}>
            You can add books & genre on Home page
          </div>
        </div>
        <div>
          <button
            className={styles.viewAllBtn}
            onClick={() => setOpenGenreHandling(true)}
          >
            Add New
          </button>
        </div>
      </Box>

      <div className={styles.tableMainContainer}>
        <TableContainer component={Paper} className={styles.tableContainer}>
          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell className={styles.indexedCell}></TableCell>
                <TableCell>Genre</TableCell>
                <TableCell>Books</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {loader ? (
                <Loader />
              ) : (
                allGenres?.map((item: any, index: number, arr: any[]) => {
                  return (
                    <TableRow
                      className={classNames(
                        arr?.length === 5 &&
                          index + 1 === arr?.length &&
                          styles.noBorder
                      )}
                    >
                      <TableCell className={styles.indexedCell}>
                        <span style={{ color: "#868e96" }}>#{index + 1}</span>
                      </TableCell>
                      <TableCell>{item?.name}</TableCell>
                      <TableCell>10 Books</TableCell>
                      <TableCell>
                        <div className={styles.actionContainer}>
                          <Tooltip arrow title="View Books">
                            <div>
                              <Icons.EyeIcon2 />
                            </div>
                          </Tooltip>
                          <Tooltip arrow title={"Delete Chat"}>
                            <div>
                              <Icons.DeleteIcon />
                            </div>
                          </Tooltip>
                          <Tooltip arrow title={"Edit"}>
                            <div>
                              <Icons.CreateActionIcon />
                            </div>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <GenreLandingPage
          open={openGenreHandling}
          handleClose={() => setOpenGenreHandling(false)}
        />
      </div>
    </div>
  );
}

export default ManageGenreOnLandingPages;

const Loader = () => {
  return (
    <>
      {Array.from({ length: 5 }).map((item, index) => {
        return (
          <>
            <TableRow className={styles.indexedCell}>
              <TableCell>
                <Skeleton variant="rounded" width={30} height={20} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" width={100} height={20} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" width={50} height={20} />
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", gap: "8px" }}>
                  <Skeleton variant="circular" width={30} height={30} />
                  <Skeleton variant="circular" width={30} height={30} />
                  <Skeleton variant="circular" width={30} height={30} />
                </div>
              </TableCell>
            </TableRow>
          </>
        );
      })}
    </>
  );
};
